import React from "react";

import { ButtonView } from "common/views/button/Button.view";
import { ImageView } from "common/views/image/Image.view";
import TypographyView from "common/views/typographyView/Typography.view";
import { Fragment } from "core/components/FragmentProvider";
import BadgeLabels from "panels/catalog/Badge.labels";
import Badge from "panels/catalog/entities/Badge";
import TokenSession from "core/util/session/TokenSession";
import ShareButton from "common/fragments/ShareButton";


export interface IBadgeDisplayProps {
	badge: Badge;
}

export const title: Fragment<IBadgeDisplayProps> = {
	name: "Title",
	// no label component because acclaim doesn't support translations, so need separate badges
	component: ({badge}) => (
		<TypographyView viewKey="badge.title">
			{badge.title}
		</TypographyView>
	)
};

export const description: Fragment<IBadgeDisplayProps> = {
	name: "Description",
	// no label component because acclaim doesn't support translations, so need separate badges
	component: ({badge}) => (
		<TypographyView viewKey="badge.description">
			{badge.description}
		</TypographyView>
	)
};

/**
 * Displays just the image (not clickable to navigate to badge page)
 */
export const staticBadgeIcon: Fragment<IBadgeDisplayProps> = {
	name: "Static Badge Icon",
	component: ({badge}) => (
		<ImageView viewKey="badge.image" src={badge.imageUrl} />
	)

};

/**
 * Displays an image that, if clicked on, takes the user to the associated badge URL
 */
export const image: Fragment<IBadgeDisplayProps> = {
	name: "Clickable Badge Icon",
	component: ({badge}) => (
		<div><a href={badge.url} target="_blank"><ImageView viewKey="badge.image" src={badge.imageUrl} /></a></div>
	)
};
/**
 * Displays a claim if pending or a view button if already claimed
 */
export const actions: Fragment<IBadgeDisplayProps> = {
	name: "Action Buttons",
	component: ({badge}) => {
		if (badge.pending) {
			return (
				<ButtonView viewKey="badge.claim" href={badge.acceptUrl}>
					<BadgeLabels.Labels.BadgeClaim />
				</ButtonView>
			);
		}

		if (!!badge.expiresAt) {
			return (
				<ButtonView viewKey="badge.view" href={badge.url}>
					<BadgeLabels.Labels.BadgeExpires args={{expiresAt: new Date(badge.expiresAt)}} />
				</ButtonView>
			);
		}
		else if (!!badge.issuedAt) {
			return (
				<ButtonView viewKey="badge.view" href={badge.url}>
					<BadgeLabels.Labels.BadgeIssuedView args={{issued: new Date(badge.issuedAt)}} />
				</ButtonView>
			);
		}

		return null;
	}
};

/**
 * Just show a claim button
 */
export const claimButton: Fragment<IBadgeDisplayProps> = {
	name: "Claim Button",
	component: ({badge}) => {
		if (badge.pending) {
			return (
				<ButtonView viewKey="badge.claim">
					<BadgeLabels.Labels.BadgeClaim />
				</ButtonView>
			);
		}

		return null;
	}
};

export const shareOnLinkedInButton: Fragment<IBadgeDisplayProps> = {
	name: "Share on LinkedIn",
	component: ({badge}) => {
		const startTask = badge.title;
		const name = badge.title;
		const organizationName = TokenSession.getContext().name;
		const certId = badge.id;
		const issueYear = new Date(badge.issuedAt).getFullYear();
		const issueMonth = new Date(badge.issuedAt).getMonth() + 1;
		const expirationYear = badge.expiresAt ? new Date(badge.expiresAt).getFullYear() : null;
		const expirationMonth = badge.expiresAt ? new Date(badge.expiresAt).getMonth() + 1 : null;
		const certUrl = badge.imageUrl;
		const buttonImage = "https://download.linkedin.com/desktop/add2profile/buttons/en_US.png";
		const shareUrl= `https://www.linkedin.com/profile/add?startTask=${startTask}&name=${name}&organizationName=${organizationName}&issueYear=${issueYear}&issueMonth=${issueMonth}&expirationYear=${expirationYear}&expirationMonth=${expirationMonth}&certUrl=${certUrl}s&certId=${certId}`;
		if(!badge.pending) {
			return (
				<ShareButton imgUrl={buttonImage} shareUrl={shareUrl} brand={"LinkedIn"} />
			)
		}
		return null;
	}
};



// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/badge/displayFragments.tsx